import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Observable } from '../../../node_modules/rxjs/Observable';
import { Company } from '../entities/company';
import { Customer } from '../entities/customer';

import { SERVER_URL } from './server-url';

@Injectable()   
export class CompanyService {
    private companyUrl = SERVER_URL + '/api/companies';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/delivery';  // URL to web API
    
    public companies:Array<Company>;

    constructor (private http: Http) {}

    getCompanies(tokenLogged:string): Observable<Company[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.companyUrl, {headers: headers})
                    .map(this.extractCompaniesFromJSON)
                    .catch(this.handleError);
    }
    
    private extractCompaniesFromJSON(res: Response | any) {
        let body = res.json();
        var companiesList:Company[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }
            var company:Company = new Company(entry.id,
                entry.name,
                entry.fantasy,
                entry.address,
                entry.number,
                entry.complement,
                entry.neighborhood,
                entry.city,
                entry.state,
                entry.country,
                entry.zipcode,
                entry.state_inscrition, 
                entry.rg,
                entry.rg_issuing_body, 
                entry.rg_issuing_body_state, 
                entry.rg_emission_date,
                entry.cpf,
                entry.cnpj,
                entry.type,
                entry.tel,
                entry.cel,
                entry.email,
                entry.delivery_address, 
                entry.delivery_number, 
                entry.delivery_complement, 
                entry.delivery_neighborhood,
                entry.delivery_city, 
                entry.delivery_state, 
                entry.delivery_country, 
                entry.delivery_zipcode, 
                entry.is_demanding_geolocation,
                entry.lat,
                entry.lng,
                entry.delivery_lat, 
                entry.delivery_lng,
                entry.time_discharge,
                entry.time_visit,
                new Customer(entry.customer_id,null,null,null,null),
                entry.id_external,
                new Date(entry.dt_last_sync),
                new Date(entry.dt_last_geolocation)
            );
            companiesList.push(company);
        }
        return companiesList;
    }

    insertCompany(tokenLogged:string, company:Company): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.companyUrl + '/insert', company, {headers: headers})
                    .map((x:any)=> { return this.resultInsert })
                    .catch(this.handleError);
    }

    private resultInsert(res: Response | any) {
        let body = res.json();
        //console.log("retorno insert => " + body);
        return 
    }

    updateCompany(tokenLogged:string, company:Company): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.companyUrl + '/update', company, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    getCompanyById(tokenLogged:string, id:number): Observable<Company> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.companyUrl + '/' + id, {headers: headers})
                    .map(this.extractCompanyFromJSON)
                    .catch(this.handleError);
    }

    private extractCompanyFromJSON(res: Response | any) {
        let body = res.json();
        let entry = body[0];
        //console.log('entry -> ' + entry);

        if (!entry.id) { return; }

        var dtLastSync = (entry.dt_last_sync) ? new Date(entry.dt_last_sync) : null;
        var dtLastGeo = (entry.dt_last_geolocation) ? new Date(entry.dt_last_geolocation) : null;

        var company:Company = new Company(
            entry.id,
            entry.name,
            entry.fantasy,
            entry.address,
            entry.number,
            entry.complement,
            entry.neighborhood,
            entry.city,
            entry.state,
            entry.country,
            entry.zipcode,
            entry.state_inscrition, 
            entry.rg,
            entry.rg_issuing_body, 
            entry.rg_issuing_body_state, 
            entry.rg_emission_date,
            entry.cpf,
            entry.cnpj,
            entry.type,
            entry.tel,
            entry.cel,
            entry.email,
            entry.delivery_address, 
            entry.delivery_number, 
            entry.delivery_complement, 
            entry.delivery_neighborhood,
            entry.delivery_city, 
            entry.delivery_state, 
            entry.delivery_country, 
            entry.delivery_zipcode, 
            entry.is_demanding_geolocation,
            entry.lat,
            entry.lng,
            entry.delivery_lat, 
            entry.delivery_lng,
            entry.time_discharge,
            entry.time_visit,
            new Customer(entry.customer_id, null, null, null, null),
            entry.id_external,
            dtLastSync,
            dtLastGeo
        );
        
        return company;
    }

    deleteCompany(tokenLogged:string, company:Company) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.companyUrl + '/deactivate', company, {headers: headers})
                    .map(this.deleteCompanyExtractFromJSON)
                    .catch(this.handleError);
        
        
    }

    private deleteCompanyExtractFromJSON(res: Response | any) {
        //console.log('Excluído');
        let body = res.json();
        let entry = body[0];
        //console.log('res -> ' + entry);

    }

    searchCompanies(tokenLogged:string, company:Company):Observable<Company[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.companyUrl + '/search', {headers: headers, params: company})
                    .map(this.extractCompaniesFromJSON)
                    .catch(this.handleError);
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            
            //errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            errMsg = body.detail || 'Ocorreu um erro no servidor.';
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
    
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/company.service.ts